import React, { useState } from "react";
import { IoCopy } from "react-icons/io5"; 

const CopyToClipboard = () => {
  const [copied, setCopied] = useState(false);
  const email = "hovarthini@gmail.com"; 
  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    });
  };

  return (
    <>
      <div className="position-relative">
        <span className="ms-2 copy-box" onClick={handleCopy} style={{ cursor: "pointer" }}>
          <IoCopy />
        </span>
        <span
          className={`text-success copied-message ms-2 ${copied ? "show" : ""}`}
        >
          Copied
        </span>
      </div>
    </>
  );
};

export default CopyToClipboard;
